angular.module('powerOfAttorney')
    .component('powerOfAttorneyShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/power-of-attorney/show.html',
        controller: function ($scope, $rootScope, $state, $window, PowerOfAttorney, PowerOfAttorneyService, Principal, PowerOfAttorneyConst) {
            this.PowerOfAttorneyService = PowerOfAttorneyService;

            this.$onInit = () => {

            }

            this.cancel = () => $window.history.back();

            $scope.$on(PowerOfAttorneyConst.eventUpdate, () => {
                $rootScope.$broadcast('document.comments.reload', this.item.id)
                $state.reload();
            })
            $scope.$on(PowerOfAttorneyConst.eventDelete, () => this.cancel())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
